import './AboutUs.css';

const AboutUs = () => (
  <main className="about-page">
    <header className="about-page__hero">
      <div className="container about-page__container">
        <span className="about-page__eyebrow">The Thakur Capital story</span>
        <h1>Knowledge is the first step toward financial independence.</h1>
        <p>We make practical market education clear, structured, and accessible for every learner.</p>
      </div>
    </header>

    <section className="container about-page__container about-founder">
      <div className="about-founder__image-wrap">
        <img src="https://thakurcapital.com/src/AS.PNG" alt="Ajit Singh, Founder of Thakur Capital" />
        <span>Founder</span>
      </div>
      <div className="about-founder__content">
        <span className="about-page__eyebrow">About Ajit Singh</span>
        <h2>Founder, Thakur Capital <em>·</em> SEBI Registered Research Analyst</h2>
        <p>Ajit Singh is a stock market educator and capital market expert with close to two decades of experience in technical and fundamental analysis. He began his career with Angel Broking in 2008 and went on to complete his graduation from Mumbai University in 2011, building his market expertise from the ground up — starting with hands-on industry experience before formalizing his analytical skills from 2012 onwards.</p>
        <p>He is a SEBI Registered Research Analyst and holds the NISM Series XV-A certification, reflecting his commitment to regulatory compliance and professional credibility in financial education.</p>
        <p>As the Founder of Thakur Capital, Ajit has trained over 1,000 students, helping them build practical skills in technical and fundamental analysis, risk management, trading psychology, and portfolio building. His teaching philosophy bridges the gap between market theory and real-world application, empowering learners to make informed, confident investment decisions.</p>
        <p>Known among his students as a Stock Market Faculty and Wealth Mentor, Ajit is dedicated to driving financial awareness and wealth creation through structured, disciplined market education — helping individuals move steadily toward financial independence.</p>
      </div>
    </section>

    <section className="about-credentials">
      <div className="container about-page__container about-credentials__grid">
        <div><strong>2008</strong><span>Industry journey began</span></div>
        <div><strong>1,000+</strong><span>Students trained</span></div>
        <div><strong>NISM XV-A</strong><span>Certified professional</span></div>
        <div><strong>SEBI</strong><span>Registered Research Analyst</span></div>
      </div>
    </section>

    <section className="container about-page__container about-capital">
      <div className="about-capital__visual"><img src="https://thakurcapital.com/src/Capture.PNG" alt="Thakur Capital" /></div>
      <div className="about-capital__content">
        <span className="about-page__eyebrow">About Thakur Capital</span>
        <h2>Market education that moves beyond theory.</h2>
        <p>Thakur Capital is a stock market education and financial learning platform dedicated to empowering individuals with practical knowledge of investing and trading.</p>
        <p>Founded with the vision of making stock market education simple and accessible, Thakur Capital provides structured learning programs, mentorship, live market sessions, and educational content designed for beginners as well as experienced market participants.</p>
        <p>The platform focuses on fundamental analysis, technical analysis, risk management, trading psychology, portfolio building, and wealth creation strategies. Through a combination of education, community support, and practical market insights, Thakur Capital aims to bridge the gap between theory and real-world market application.</p>
      </div>
    </section>

    <section className="about-mission">
      <div className="container about-page__container">
        <span className="about-page__eyebrow">Our mission</span>
        <h2>Financial confidence, built through knowledge.</h2>
        <p>At Thakur Capital, our mission is to help individuals gain financial confidence, make informed investment decisions, and begin their journey toward financial freedom through knowledge and disciplined market participation.</p>
      </div>
    </section>
  </main>
);

export default AboutUs;
